import { CommonModule, NgIf } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import {
  Component,
  OnInit
}
  from '@angular/core';

import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
}
  from '@angular/forms';

import {
  Router,
  RouterLink
}
  from '@angular/router';

import Swal from 'sweetalert2';

import {
  FlyingbeesService
}
  from '../flyingbees.service';

@Component({

  selector: 'app-bees-header',

  standalone: true,

  imports: [
    RouterLink,
    NgIf,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],

  templateUrl:
    './bees-header.component.html',

  styleUrls: [
    './bees-header.component.scss'
  ]

})

export class BeesHeaderComponent
  implements OnInit {

  ContactFrm!: FormGroup;

  mobileMenuOpen = false;

  showRegister = false;

  constructor(

    private manas: FlyingbeesService,

    private router: Router

  ) { }

  ngOnInit(): void {

    this.ContactFrm =
      new FormGroup({

        name:
          new FormControl(
            '',
            Validators.required
          ),

        email:
          new FormControl(
            '',
            [
              Validators.required,
              Validators.email
            ]
          ),

        phone_number:
          new FormControl(
            '',
            [
              Validators.required,
              Validators.minLength(10),
              Validators.maxLength(10)
            ]
          ),

        message:
          new FormControl('')

      });

  }

  toggleMobileMenu() {

    this.mobileMenuOpen =
      !this.mobileMenuOpen;

    const mobileMenu =
      document.querySelector(
        '.mobile-nav__wrapper'
      );

    if (mobileMenu) {

      if (
        this.mobileMenuOpen
      ) {

        mobileMenu.classList.add(
          'expanded'
        );

      } else {

        mobileMenu.classList.remove(
          'expanded'
        );

      }

    }

  }

  openRegister() {

    this.showRegister = true;

  }

  closeRegister() {

    this.showRegister = false;

  }

  closeModal() {

    this.showRegister = false;

  }

  /* SUBMIT */

  feedback() {

    if (
      this.ContactFrm.invalid
    ) {

      this.ContactFrm.markAllAsTouched();

      return;

    }

    /* CLOSE MODAL IMMEDIATELY */

    this.showRegister = false;

    this.closeModal();

    this.manas.ContactFrm(

      this.ContactFrm.value.name,

      this.ContactFrm.value.email,

      this.ContactFrm.value.phone_number,

      this.ContactFrm.value.message

    )

      .subscribe({

        next: (res: any) => {

          console.log(res);

          /* SUCCESS */

          if (
            res.status === 'success'
          ) {

            this.ContactFrm.reset();

            Swal.fire({

              title:
                'Success',

              text:
                'Password sent to your email. Use it to access the page.',

              icon:
                'success',

              confirmButtonText:
                'OK'

            });

          }

          /* DUPLICATE */

          else if (

            res.status === 'error'

            &&

            res.message ===

            'Phone already exists'

          ) {

            Swal.fire({

              title:
                'Duplicate Mobile',

              text:
                'This mobile number already registered',

              icon:
                'error'

            });

          }

          /* OTHER */

          else {

            Swal.fire({

              title:
                'Error',

              text:
                res.message,

              icon:
                'error'

            });

          }

        },

        error: (err) => {

          console.log(err);

          Swal.fire({

            title:
              'Server Error',

            text:
              'Please try again later',

            icon:
              'error'

          });

        }

      });

  }

}